module.exports = __webpack_public_path__ + "static/media/0026_LES_ENSEIGNES_LE_BOUCHER_LETTRE_A_LETTRE.68ab2bbd.png";